var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928 432a334.72 334.72 0 0 0-274.24-329.92A184 184 0 0 0 608 96H288a192 192 0 0 0-192 192v192h13.76A239.68 239.68 0 0 0 288 794.88V928h224v-64h278.4l137.6 91.84V576a96 96 0 0 0-13.76-49.28A340.8 340.8 0 0 0 928 432z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M592 432m-304 0a304 304 0 1 0 608 0 304 304 0 1 0-608 0Z",
    fill: "#E9EAEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336 560m-208 0a208 208 0 1 0 416 0 208 208 0 1 0-416 0Z",
    fill: "#E9EAEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M768 288a160 160 0 0 0-160-160H288a160 160 0 0 0-160 160v160h192v448h160V448h288z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M768 288v160h-96v-96a64 64 0 0 0-64-64 64 64 0 0 0-64 64v96h-96V288a160 160 0 0 1 320 0z",
    fill: "#ffad0a26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M896 576a64 64 0 0 0-64-64H448a64 64 0 0 0-64 64v192a64 64 0 0 0 64 64h352l96 64v-128z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M832 544a32 32 0 0 1 32 32v260.16l-46.4-32-8-4.16H448a32 32 0 0 1-32-32v-192a32 32 0 0 1 32-32h384m0-32H448a64 64 0 0 0-64 64v192a64 64 0 0 0 64 64h352l96 64V576a64 64 0 0 0-64-64z",
    fill: "#FFAE0A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M704 704h96v32h-96zM480 704h192v32h-192zM480 608h96v32h-96z",
    fill: "#FFAE0A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M608 128H288a160 160 0 0 0-160 160v160h192v448h160v-32h-128V448h96v32h32v-32h288V288a160 160 0 0 0-160-160z m-160 160v128H160V288a128 128 0 0 1 128-128h224a160 160 0 0 0-64 128z m288 128h-256V288a128 128 0 0 1 256 0z",
    fill: "#FFAE0A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M384 256H224v32h160V256zM384 320H224v32h160v-32z",
    fill: "#FFAE0A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotification);
export default __webpack_public_path__ + "static/media/empty-notification.b1dd4677e1d735007737ae9dbc9f49c5.svg";
export { ForwardRef as ReactComponent };